import React, { useEffect, useState } from "react";
import './alluserforadmin.css';
import CreateNewUser from './adminusercomponent/createnewuser'
import Popup from 'reactjs-popup';
import axios from "axios";
import OverLay from './overlay';
const AllUserForAdmin=(props)=>{
    let [data, setdata]=useState([])
    const [load, setload]=useState(false)
    const get_user_list_admin=()=>{
        axios.get('/get_user_list_admin?user_id='+props.userData.id).then((res)=>{
            console.log(res.data)
            if(Array.isArray(res.data)){
                res.data.forEach(key=>{
                    if(key.status==='Active'){
                        key.approve=true
                    }else{
                        key.approve=false
                    }

                    key.deluse=false
                    key.showfalsereq=false
                    key.reqData=[]
                })
                setdata(res.data)
            }
        })
    }
    const update_approve_status_request=(status, reqid, userid, i, j)=>{
        console.log(status, reqid, userid)
        setload(true)
        axios.get('/update_approve_status_request?status='+status+'&reqid='+reqid+'&userid='+userid+'&adminuserid='+props.userData.id).then((res)=>{
            if(res.data==='Successfully updated'){
                if(status==='Approved'){
                    let ndata=[...data]
                    ndata[i].reqData[j].approval_status='Approved'
                    setdata(ndata)
                    alert(res.data)
                    }
                if(status==='Not Approved'){
                    let ndata=[...data]
                    ndata[i].reqData[j].approval_status='Not Approved'
                    setdata(ndata)
                    alert(res.data)
                    }
                }else{
                    alert(res.data)
                }
                
            setload(false)
        })
    }
    const getallrequestByUserId=(userid, i, email,showfalsereq)=>{
        console.log('show req', showfalsereq)
        if(showfalsereq===false){
            setload(true)
            axios.get('/get_web_app_request_for_approval?userid='+userid).then((res)=>{
                let ndata=[...data]
                ndata[i].reqData=[]
                ndata[i].reqData=res.data
                ndata.forEach(key=>{
                if(email===key.email){
                    ndata[i].showfalsereq=!showfalsereq
                }else{
                    key.showfalsereq=false
                }
                })
                setdata(ndata)
                setload(false)
            })
        }else{
            let ndata=[...data]
            ndata.forEach(key=>{
            if(email===key.email){
                ndata[i].showfalsereq=!showfalsereq
            }else{
                key.showfalsereq=false
            }
            })
            setdata(ndata)
        }
    }
    const InActiveActive=(val, index, id)=>{
        let status=val?'InActive':'Active'
        axios.get('/active_inactive_user?userId='+id+'&status='+status)
        .then((res)=>{
            if(res.data){
                alert(res.data)
                console.log(res.data)
                let ndata=[...data]
                ndata[index].approve=!val;
                setdata(ndata)
            }
        })
    }
    useEffect(()=>{
        get_user_list_admin()
    },[])
    return(
        <div className='ContainerCard'>
        <div style={{paddingRight:0}}>
            {data.map((val, i)=>{
                return(
                    <div key={i} className="card">
                        <div class="card-body">
                            <div style={{display:'flex'}}>
                                <div style={{width:'80%'}}>
                                    <h5 className="card-title">{val.name}</h5> 
                                    <div>
                                        <a href={'mailto:'+val.email} target='_blank'>
                                            <p className='card-text' style={{
                                                color:'gray',
                                                fontSize:12
                                            }}>{val.email}</p>
                                        </a>
                                    </div> 
                                    <a 
                                    className='userdetailslink'
                                    style={{
                                        fontSize:12,
                                        textDecoration:'underline',
                                    }}
                                    onClick={()=>{
                                        getallrequestByUserId(val.id, i, val.email,val.showfalsereq)
                                        
                                    }}
                                    type="button">{val.showfalsereq?'Hide User Request':'Show User Request'}</a>
                                    {/*
                                        <a 
                                        className='userdetailslink'
                                        style={{
                                            fontSize:12,
                                            textDecoration:'underline',
                                            marginLeft:10,
                                        }}
                                        onClick={()=>{
                                            
                                        }}
                                        type="button">View Request</a>
                                    */}
                                    <div>
                                        {val.showfalsereq&&
                                            <div>
                                            {val.reqData.length===0?<div>
                                                    <span>No Request Found</span>
                                                </div>:
                                                <table className='table_alluser' style={{
                                                    width:'100%',
                                                    textAlign:'center'
                                                }}>
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" className='table_alluser'>Request Id</th>
                                                            <th scope="col" className='table_alluser'>Service</th>
                                                            <th scope="col" className='table_alluser'>City</th>
                                                            <th scope="col" className='table_alluser'>Created By</th>
                                                            <th scope="col" className='table_alluser'>Created At</th>
                                                            <th scope="col" className='table_alluser'>Approval Status</th>
                                                            <th scope="col" className='table_alluser'>Update Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                            {val.reqData.map((reqval, j)=>{
                                                                return(
                                                                <tr key={j}>
                                                                    <td className='table_alluser'>
                                                                        <span>{reqval.reqId}</span>
                                                                    </td>
                                                                    <td className='table_alluser'>
                                                                        <span>{reqval.service}</span>
                                                                    </td>
                                                                    <td className='table_alluser'>
                                                                        <span>{reqval.city}</span>
                                                                    </td>
                                                                    <td className='table_alluser'>
                                                                        <span>{reqval.created_by}</span>
                                                                    </td>
                                                                    <td className='table_alluser'>
                                                                        <span>{reqval.created_at}</span>
                                                                    </td>
                                                                    <td className='table_alluser'>
                                                                        <span>{reqval.approval_status===null?'Not Approved':reqval.approval_status}</span>
                                                                    </td>
                                                                    <td className='table_alluser'>
                                                                        <a type='button'
                                                                        className='userdetailslink'
                                                                        style={{
                                                                            fontSize:12,
                                                                            textDecoration:'underline',
                                                                        }}
                                                                        onClick={()=>{
                                                                            if(reqval.approval_status===null||reqval.approval_status==="Not Approved"){
                                                                                update_approve_status_request('Approved', reqval.reqId, val.id, i, j)
                                                                            }else{
                                                                                update_approve_status_request('Not Approved',reqval.reqId, val.id, i, j)
                                                                            }
                                                                        }}>{reqval.approval_status===null||reqval.approval_status==="Not Approved"?'Click Here to Approved':'Reject'}</a>
                                                                    </td>
                                                                </tr>
                                                            )})}
                                                    </tbody>
                                                </table>
                                            }
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div style={{width:'20%', display:'flex', flexDirection:'row', 
                                        justifyContent:'space-between',
                                        alignItems:'baseline'
                            }}>
                                <button style={{
                                    whiteSpace:'normal'
                                }} type="button" class="btn btn-outline-success" onClick={()=>{
                                    InActiveActive(val.approve, i, val.id)
                                    
                                }}>{val.approve?'Inactive':'Active'}</button>
                                {/*
                                    <button 
                                    style={{
                                        whiteSpace:'normal'
                                    }} type="button" class="btn btn-outline-danger">Delete</button>
                                */}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
            <Popup  overlayStyle={{
                // background:'transparent'
            }} contentStyle={{
                background:'transparent',
                border:0,
                padding:0,
                width:'auto'
            }} trigger={<button type="button" style={{
                marginTop:5
            }} className="btn btn-success">Create New User</button>} position="right center" modal nested>
                {close=>(
                    <div>
                        <button className="close" onClick={close}>
                            &times;
                        </button>
                        <div>
                            <CreateNewUser {...props}/>
                        </div>
                    </div>
                )}
            </Popup>
        </div>
            <OverLay active={load}/>
        </div>
    )
}
export default AllUserForAdmin;